import styled from "styled-components";

export const Body = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  column-gap: 25px;
`;
